module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diana L. Paxson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Diana L. Paxson is the award-winning author of "), _c('I', [_vm._v("The Lord of Horses, The Wolf and the Raven, The Dragons of the Rhine, The White Raven,")]), _vm._v(" and "), _c('I', [_vm._v("The Serpents Tooth,")]), _vm._v(" and coauthor (with Adrienne Martine-Barnes) of "), _c('I', [_vm._v("Master of Earth and Water, The Shield Between the Worlds,")]), _vm._v(" and "), _c('I', [_vm._v("Sword of Fire and Shadow,")]), _vm._v(" the chronicles of Fionn mac Cumhal. She lives in Berkeley, California.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gbv9Dv/tc-custom/9780062290953.jpg?1731012178756",
      "alt": "This image is the cover for the book Hallowed Isle: The Book of the Cauldron, The Hallowed Isle"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hallowed Isle: The Book of the Cauldron, The Hallowed Isle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Romans came, conquered, and departed, leaving behind them a strange new religion called Christianity. The princes of Britannia have driven back the invading Saxons and dream of a return to bygone days, while others on the island invoke the magic of a time older still. For the revered ancient goddesses Eve on in the hearts and memories of the proud royal women of the old British tribes. And now, King Artor -- wounded in body and spirit -- proclaims that the sword and the spear must be put to rest, and summons his mother Igierne, Lady of the Lake, to use the powers of the Cauldron to heal a troubled, wartorn land. But old jealousies and new power struggles threaten disaster, as Artor's sister Morgause hides a deadly secretand a darker magic. It is Guendivar the queen who holds the key to their survival, if she can master her own power in time.")]), _c('p', [_vm._v("For a darkness is emanating from high places -- and it threatens to devastate a realm.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0